/// <reference path="../types.js" />

import BaseComponent from './base.js';

/**
 * @param {Props<HTMLSpanElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLSpanElement>}
 */
const span = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'span' }, ...children);

/**
 * @param {UtilTagProps<HTMLDivElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLDivElement>}
 */
const div = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'div' }, ...children);

/**
 * @param {UtilTagProps<HTMLHeadingElement>} [props]
 * @returns {BaseComponent<HTMLHeadingElement>}
 */
const h1 = (props) => new BaseComponent({ ...props, elementTag: 'h1' });

/**
 * @param {UtilTagProps<HTMLInputElement>} [props]
 * @returns {BaseComponent<HTMLInputElement>}
 */
const input = (props) => new BaseComponent({ ...props, elementTag: 'input' });

/**
 * @param {UtilTagProps<HTMLAnchorElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLAnchorElement>}
 */
const a = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'a' }, ...children);

/**
 * @param {UtilTagProps<HTMLLabelElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLLabelElement>}
 */
const label = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'label' }, ...children);

/**
 * @param {UtilTagProps<HTMLImageElement>} [props]
 * @returns {BaseComponent<HTMLImageElement>}
 */
const img = (props) => new BaseComponent({ ...props, elementTag: 'img' });

/**
 * @param {UtilTagProps<HTMLButtonElement>} [props]
 * @returns {BaseComponent<HTMLButtonElement>}
 */
const button = (props) => new BaseComponent({ ...props, elementTag: 'button' });

/**
 * @param {UtilTagProps<HTMLDetailsElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLDetailsElement>}
 */
const details = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'details' }, ...children);

/**
 * @param {UtilTagProps<HTMLElement>} [props]
 * @returns {BaseComponent<HTMLElement>}
 */
const summary = (props) =>
  new BaseComponent({ ...props, elementTag: 'summary' });

/**
 * @param {UtilTagProps<HTMLUListElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLUListElement>}
 */
const ul = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'ul' }, ...children);

/**
 * @param {UtilTagProps<HTMLLIElement>} [props]
 * @param {...(HTMLElement | BaseComponent<HTMLElement>)} children
 * @returns {BaseComponent<HTMLLIElement>}
 */
const li = (props, ...children) =>
  new BaseComponent({ ...props, elementTag: 'li' }, ...children);

export default {
  span,
  div,
  h1,
  input,
  label,
  a,
  img,
  button,
  details,
  summary,
  ul,
  li,
};
